/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".council-brand[_ngcontent-%COMP%]{margin-top:-10px}.council-logo[_ngcontent-%COMP%]{display:inline-block!important;margin-right:10px}.navbar-council[_ngcontent-%COMP%]{background:#1fb53b;color:#fff}.navbar-council[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff}.navbar-text[_ngcontent-%COMP%] > a.disabled[_ngcontent-%COMP%]{pointer-events:none;cursor:default;opacity:.6;text-decoration:none}\n/*# sourceMappingURL=navbar.component.css.map*/"];
export { styles as styles };
